var MS_IN_DAY = 86400000;
var DAYS_IN_WEEK = 7;
var MS_IN_WEEK = MS_IN_DAY * DAYS_IN_WEEK;
export default {
  MS_IN_DAY: MS_IN_DAY,
  DAYS_IN_WEEK: DAYS_IN_WEEK,
  MS_IN_WEEK: MS_IN_WEEK
};